import React from "react";
import { PaystackButton } from "react-paystack";
import { Button } from "antd";
import getPayStackKey from "../Utils/getPaystackKeys";
import {
  // checkPaymentIntent,
  // createPaymentIntent,
  // disableCart,
  updateItemsInCart,
  // updatePaymentIntent,
} from "../redux/Actions";

function PayStackButtonMethod(props) {
  const {
    userProfileDetails,
    setIsLoadingPayment,
    locationDetails,
    dispatch,
    postVerifyTransaction,
    isLoadingPayment,
    showModal,
    isOrderButtonDisabled,
    authuserdetails,
    totalCost,
    isloadingUpdatedCartItem,
    latestUpdatedCartItem,
  } = props;

  const handleUpdatedCartItem = () => {
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        })
      );
    }
    // You can perform any action here before the payment dialog opens
  };

  const psconfig = {
    reference: `NB${Date.now()}`,
    email: authuserdetails.email,
    amount: parseInt(totalCost * 100), // Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    publicKey: getPayStackKey(),
    // onclick: handleUpdatedCartItem(),
    metadata: {
      name: authuserdetails.name,
      phone: authuserdetails.phone,
    },
  };

  const handlePaystackSuccessAction = (reference) => {
    // console.log(reference);
    // debugger
    dispatch(
      postVerifyTransaction({
        reference: reference.reference,
        transaction_id: reference.transaction,
        location_id: locationDetails,
        payment_channel: "paystack",
        is_direct: false,
      })
    );
    setIsLoadingPayment(false);
    // const channel = new BroadcastChannel('payment_channel');
    // channel.postMessage({ action: 'enableCart' });
  };

  const handlePaystackCloseAction = () => {
    console.log("closed");
    setIsLoadingPayment(false);
    // dispatch(enableCart());
    // dispatch(updatePaymentIntent(authuserdetails?.id))
    // dispatch(checkPaymentIntent())
    // const channel = new BroadcastChannel('payment_channel');
    // channel.postMessage({ action: 'enableCart' });
  };

  const componentProps = {
    ...psconfig,
    text: (
      <>
        <img
          src={
            "https://pluginicons.craft-cdn.com/commerce-paystackB9kA1pnH1vXzDH6GVLhRwcFRgcBVfIrmICuD.svg?1592998530"
          }
          alt="Paystack"
          style={{ height: "1.5em" }}
        />{" "}
        Pay with Paystack
      </>
    ),
    icon: "",
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
    // onclick: handleUpdatedCartItem(),
  };

  const isButtonDisabled =
    isOrderButtonDisabled || isLoadingPayment || isloadingUpdatedCartItem;

  const handleverifystat = () => {
    showModal();
  };

  // const handlePayment =()=>{
  // dispatch(createPaymentIntent('paystack'))
  // dispatch(disableCart())
  // const channel = new BroadcastChannel('payment_channel');
  // channel.postMessage({ action: 'disableCart' });
  // }

  return (
    <>
      {isButtonDisabled ? (
        <Button
          block
          className="paystackpaymentbutton typography mt-2"
          disabled={isButtonDisabled}
          icon={
            <img
              src={
                "https://pluginicons.craft-cdn.com/commerce-paystackB9kA1pnH1vXzDH6GVLhRwcFRgcBVfIrmICuD.svg?1592998530"
              }
              alt="Paystack"
              style={{ height: "1.5em" }}
            />
          }
        >
          Pay with Paystack
        </Button>
      ) : userProfileDetails?.data?.status === 0 ? (
        <Button
          style={{ width: "100%" }}
          className="paystackpaymentbutton typography mt-2"
          onClick={handleverifystat}
          icon={
            <img
              src={
                "https://pluginicons.craft-cdn.com/commerce-paystackB9kA1pnH1vXzDH6GVLhRwcFRgcBVfIrmICuD.svg?1592998530"
              }
              alt="Paystack"
              style={{ height: "1.5em" }}
            />
          }
        >
          Pay with Paystack
        </Button>
      ) : (
        <div onClick={handleUpdatedCartItem}>
          <PaystackButton
            style={{ width: "100%" }}
            className="paystackpaymentbutton typography mt-2"
            {...componentProps}
            // onClick={handleUpdatedCartItem}
          />
        </div>
      )}
    </>
  );
}

export default PayStackButtonMethod;
